import { render, staticRenderFns } from "./NextSteps.vue?vue&type=template&id=49248534&"
import script from "./NextSteps.ts?vue&type=script&lang=ts&"
export * from "./NextSteps.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports